import React, {Component} from "react";
import {
    Accordion,
    Form,
    Header,
    Segment,
    Grid,
    Input,
    Button
} from "semantic-ui-react";
import GridFormInput from './TableGridFormInput'

class FilterForm extends Component {
    state = {filter: {status: 'Active'}}

    handleChange(e, value) {
        let filter = this.state.filter
        filter[value.name] = value.value
        this.setState({filter})
    }

    handleClick() {
        this.props.filter(this.state.filter)
    }

    handleClear() {
        this.setState({filter: {first_name: "", last_name: "", created_at: "", email: "", id:""}})
        this.props.filter({})
    }

    render() {
        let filter = this.state.filter
        return (<Form>
            <Grid>
                <Grid.Row>
                    <Grid.Column width={3}>
                        <Header as='h5' attached='top'>
                            Status
                        </Header>
                        <Segment attached>
                            <Form.Group grouped>
                                <Form.Radio label='True' name='status' type='radio' value='Active'
                                            checked={filter['status'] === 'Active'}
                                            onChange={this.handleChange.bind(this)}/>
                                <Form.Radio label='False' name='status' type='radio' value='Locked'
                                            checked={filter['status'] === 'Locked'}
                                            onChange={this.handleChange.bind(this)}/>
                            </Form.Group></Segment>
                    </Grid.Column>
                    <Grid.Column width={5}>
                        <GridFormInput
                            label="First Name"
                            component={<Input style={{width: 200}}
                                              value={filter.first_name}
                                              name='first_name'
                                              placeholder='First Name'
                                              onChange={this.handleChange.bind(this)}/>}/>
                        <GridFormInput
                            label="Last Name"
                            component={<Input style={{width: 200}}
                                              value={filter.last_name}
                                              name='last_name'
                                              placeholder='Last Name'
                                              onChange={this.handleChange.bind(this)}/>}/>
                        <GridFormInput
                            label="Created At"
                            component={<Input style={{width: 200}}
                                              value={filter.created_at}
                                              name='created_at'
                                              type='date'
                                              placeholder='Created At'
                                              onChange={this.handleChange.bind(this)}/>}/>
                    </Grid.Column>
                    <Grid.Column width={8}>
                        <GridFormInput
                            label="Email"
                            component={<Input style={{width: 200}}
                                              value={filter.email}
                                              name='email'
                                              placeholder='Email'
                                              onChange={this.handleChange.bind(this)}/>}/>
                        <GridFormInput
                            label="ID"
                            component={<Input style={{width: 200}}
                                              value={filter.id}
                                              name='id'
                                              placeholder='ID'
                                              onChange={this.handleChange.bind(this)}/>}/>
                        <div style={{
                            position: "absolute",
                            right: 10,
                            bottom: 0,
                        }}>
                            <Button onClick={this.handleClear.bind(this)}>Clear</Button>
                            &nbsp;
                            <Button color='teal'
                                    onClick={this.handleClick.bind(this)}>Filter</Button>
                        </div>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
            <Grid>

            </Grid>

        </Form>)
    }
}

export class Filter extends Component {
    state = {activeIndex: -1}

    handleClick = (e, titleProps) => {
        const {index} = titleProps
        const {activeIndex} = this.state
        const newIndex = activeIndex === index ? -1 : index

        this.setState({activeIndex: newIndex})
    }

    render() {
        const {activeIndex} = this.state

        return (
            <Accordion fluid styled>
                <Accordion.Title
                    active={activeIndex === 0}
                    content='Filter'
                    index={0}
                    onClick={this.handleClick}
                />
                <Accordion.Content active={activeIndex === 0}>
                    <FilterForm filter={this.props.filter}/>
                </Accordion.Content>
            </Accordion>
        )
    }
}

export default Filter
